<template>
  <v-text-field
    @keypress="onlyAllowNumber($event)"
    @focus="hasFocus = true"
    @blur="hasFocus = false"
    :variant="isLineItem ? 'solo-filled' : undefined"
    :hide-details="isLineItem ? 'auto' : ''"
    :prepend-icon="isCurrency && isLineItem ? 'mdi-currency-usd' : ''"
    :append-icon="highlight && documentMetadata.autoExtracted ? 'mdi-auto-fix' : ''"
    ref="textField"
    v-bind:class="{ 'pt-4': !isLineItem }"
    type="number"
    :disabled="documentMetadata.metadata.isReadonly"
    v-model="localValue"
    :label="label"
    :bg-color="highlight ? 'metadataHighlight' : 'transparent'"
    :data-cy="documentMetadata.metadata.key"
  ></v-text-field>
</template>

<script>
import valdationService from "@/services/validationService";
import metadataType from "@/constants/metadataType";
import documentMetadataService from "@/services/documentMetadataService";
import metadataMixin from "@/mixins/metadataMixin";

export default {
  name: "NumericMetadata",

  // Use the mixin to handle prop mutations properly
  mixins: [metadataMixin],

  props: {
    // documentMetadata is provided by the mixin
    textSelection: Object,
    isLineItem: Boolean,
    focusOnLoad: Boolean,
    onClickToFill: Function,
  },

  data() {
    return {
      highlight: false,
      onlyAllowNumber: valdationService.onlyAllowNumber,
      hasFocus: false,
    };
  },

  created() {
    // Use the mixin's helper method instead of direct mutation
    this.clearHighlightAfterDelay();
    documentMetadataService.focusIfRequested(this);
  },

  computed: {
    // localValue is provided by the mixin and emits events on set
    isCurrency() {
      return this.documentMetadata.metadata.metadataType.id === metadataType.Currency;
    },
    label() {
      return this.isLineItem ? "" : this.documentMetadata.metadata.name;
    },
  },

  watch: {
    textSelection: {
      handler() {
        // Check if this field has focus using our tracked state
        if (!this.hasFocus) return;

        let value = valdationService.textToNumber(this.textSelection.text);
        // Setting localValue now emits an event instead of mutating directly
        this.localValue = isNaN(parseFloat(value)) ? "" : parseFloat(value);

        documentMetadataService.assignTextSelection(this);

        // Show highlight effect when text is selected from PDF
        this.highlight = true;
        setTimeout(() => {
          this.highlight = false;
        }, 2000);

        if (this.onClickToFill) this.onClickToFill();
      },
      deep: true,
    },
    focusOnLoad() {
      documentMetadataService.focusIfRequested(this);
    },
  },
};
</script>
